import { List, Log, MapRoad } from '@icon-park/react';
import type { ReactElement } from 'react';

import { LESSON_SEQUENCE_TYPES } from '@didaskill/domain/lessons/constants';

export const LESSON_SEQUENCE_TYPES_ICON_MAP: Record<LESSON_SEQUENCE_TYPES, ReactElement> = {
  [LESSON_SEQUENCE_TYPES.TEXT]: <Log />,
  [LESSON_SEQUENCE_TYPES.TRAINING]: <List />,
  [LESSON_SEQUENCE_TYPES.ACTIVITY]: <MapRoad />,
} as const;
